import { Flex, Text } from "@minervaproject/fds";

import { FlightErrorBoundary } from "components/error_boundary";
import { NewMinervaResources } from "components/sidebar/resources/new_minerva_resources";
import { NewUrlAndFileResources } from "components/sidebar/resources/new_url_and_file_resources";

function NewResources({
  canControlClassroom,
  activeBreakoutSessionId,
}: {
  canControlClassroom: boolean;
  activeBreakoutSessionId?: string;
}) {
  return (
    <Flex direction="column" none className="mb5">
      <Text className="body-l flex-none" kind="h2" mb={4}>
        New Resources
      </Text>
      {(canControlClassroom || activeBreakoutSessionId) && <NewMinervaResources />}
      <FlightErrorBoundary text="Resource uploading form cannot be displayed">
        <NewUrlAndFileResources />
      </FlightErrorBoundary>
    </Flex>
  );
}

export { NewResources };
